// !IMPORTANT: keys must be unique
export var formatters = [{
  key: "none",
  text: "None",
  formatter: null
}, {
  key: "integer",
  text: "Integer (1,000)",
  formatter: "0,0"
}, {
  key: "decimal",
  text: "Decimal (1,000.00)",
  formatter: "0,0.00"
}, {
  key: "percentage",
  text: "Percent (%)",
  formatter: "0%"
}];
export var errors = {
  name_too_long: "name_too_long",
  name_invalid: "name_invalid",
  name_exists: "name_exists",
  empty_value: "empty_value",
  circular_dependency: "circular_dependency",
  column_empty_name: "column_empty_name",
  column_name_exists: "column_name_exists",
  column_name_not_allowed: "column_name_not_allowed",
  column_name_too_long: "column_name_too_long",
  column_formula_circular_dependency: "column_formula_circular_dependency"
};
export var columnCellsTypes = {
  select: {
    type: "select",
    config: {
      values: []
    }
  }
};
export var NODE_NAME_MAX_LENGTH = 15;
export var StructTableKeywords = {
  all: "[#All]",
  data: "[#Data]",
  headers: "[#Headers]",
  totals: "[#Totals]"
};